import { required, domain } from "../rules";

const addPointerDomain = {
  domain: {
    domain,
    required,
  },
  type: {
    required,
  },
};

export default addPointerDomain;
